<template>
    <PrismicImage
        v-if="prismicImage"
        :class="imageClass"
        :field="prismicImage"
        :loading="loading"
        :provider="provider"
        :height="height || prismicImage.dimensions.height"
        :width="width || prismicImage.dimensions.width"
        :imgix-params="{auto: ['enhance', 'format']}"
        :widths="widths"
    />
</template>

<script setup lang="ts">
    import {PrismicImage} from '@prismicio/vue';

    defineProps({
        loading: {type: String, required: false, default: 'lazy'},
        provider: {type: String, required: false, default: undefined},
        prismicImage: {
            type: Object,
            required: false,
            default: undefined,
        },
        height: {type: String, required: false, default: undefined},
        width: {type: String, required: false, default: undefined},
        widths: {type: Array<number>, required: false, default: undefined},
        imageClass: {type: String, required: false, default: undefined},
    });
</script>
